module.exports = __webpack_public_path__ + "img/courrier.ee570b93.jpg";